import {Directive, DoCheck, ElementRef, Input} from '@angular/core';

@Directive({
    selector: '[afTextMiddleEllipsis]',
    standalone: false
})
export class TextMiddleEllipsisDirective implements DoCheck {
    @Input('afTextMiddleEllipsis') inputText?: string;
    private lastTextValue = '';

    constructor(private el: ElementRef) {}

    ngDoCheck(): void {
        const currentText = this.inputText
            ? this.inputText
            : this.el.nativeElement.textContent.trim();

        if (currentText !== this.lastTextValue) {
            this.lastTextValue = currentText;
            this.el.nativeElement.textContent = this.middleCrop(currentText);
        }
    }

    private middleCrop(text: string): string {
        const maxLength = 21;
        if (text.length <= maxLength) {
            return text;
        }

        const dotIndex = text.lastIndexOf('.');
        let endPart = '';

        if (dotIndex !== -1) {
            const beforeDot = Math.max(dotIndex - 2, 0);
            endPart = text.substring(beforeDot, dotIndex) + text.substr(dotIndex);
        } else {
            endPart = text.substring(Math.max(text.length - 5, 0));
        }

        const remainingLength = maxLength - endPart.length - 3;
        const startPart = text.substring(0, Math.max(remainingLength, 0));

        return startPart + '...' + endPart;
    }
}
